import { IconWrapper } from '../runtime';
export default IconWrapper('mobile-sharing-one', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 48 48",
      "fill": "none"
    }
  }, [h("circle", {
    "attrs": {
      "cx": "24",
      "cy": "24",
      "r": "24",
      "fill": 'url(#' + props.id + '9f9cc0e5' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M16.7143 12C15.7675 12 15 12.7675 15 13.7143V34.2857C15 35.2325 15.7675 36 16.7143 36H30.2857C31.2325 36 32 35.2325 32 34.2857V13.7143C32 12.7675 31.2325 12 30.2857 12H16.7143ZM21.7143 29.5714C20.7675 29.5714 20 30.3389 20 31.2857C20 32.2325 20.7675 33 21.7143 33H25.2857C26.2325 33 27 32.2325 27 31.2857C27 30.3389 26.2325 29.5714 25.2857 29.5714H21.7143Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '9f9cc0e5',
      "x1": "0",
      "y1": "0",
      "x2": "48",
      "y2": "48",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#8497B8"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#60718D"
    }
  })])])]);
});